module.exports = __webpack_public_path__ + "static/media/bhawani.436bb33a.jpg";